import type { FormField } from '@cli-types/core-engine/schema.js'

export function unsupportedFormFieldTypeMessage(field: FormField): string {
  return `Form field "${field.name || 'unnamed'}" has unsupported type "${String(field.type)}".`
}
